import { BaseTicketController } from '../../../../../common/base/ticketController';

export class DWSStartedController extends BaseTicketController {
  constructor(controllerService, ticketService) {
    'ngInject';
    super({ controllerService, ticketService });
  }

  $onInit() {
    super.$onInit();
  }

  completeDWS() {
    this.isLoading = true;
    this.ticketService
      .completeDWS(this.ticket.id)
      .finally(() => (this.isLoading = false));
  }
}
